import OwlCarousel from "react-owl-carousel3";
import batuk from "../../assets/images/new/fav-removebg-preview.png";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { LoaderContext } from "../../AuthContext/AuthContext";
import { t } from "i18next";

const PopularProducts = ({ productList }) => {
    const { setLoader, selectedLanguageID, pujaStatus, formatToIndianCurrency } = useContext(LoaderContext);
    const navigate = useNavigate()
    const handleNavigation = (slug) => {

        navigate(`/product-details/${slug}`);

    };

    const stripHtml = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.innerText || tempDiv.textContent || "";
    };
    const options = {
        loop: productList?.length > 3,
        rewind: true, // Enable rewind instead of looping
        margin: 30,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        smartSpeed: 800,
        navText: [
            "<i class='fas fa-arrow-left'></i>",
            "<i class='fas fa-arrow-right'></i>",
        ],
        responsive: {
            0: {
                items: 1, // 1 item on small screens
            },
            600: {
                items: 2, // 2 items on medium screens
            },
            1000: {
                items: 4, // 3 items on large screens
            },
        },
    };
    return (
        <>
            {/* Trending products */}
            <section
                className="blog-section p-1"
                style={{ marginBottom: "50px", backgroundColor: "#f1f6f7" }}
            >
                <div
                    className="container mb-0"
                    style={{ display: "flex", flexDirection: "column" }}
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="section-title text-center mb-0">
                                {/* <h2>
            {" "}
            <span className="sec-title__tagline__border"></span>Trending Posts
          </h2> */}
                                <h6
                                    className="sec-title__tagline bw-split-in-right"
                                    style={{ perspective: "400px" }}
                                >
                                    <img className=" tagline-img" src={batuk} alt="" />
                                    {t("Trending Products")}
                                </h6>
                                <h3
                                    className="sec-title__title bw-split-in-left"
                                    style={{ perspective: "400px" }}
                                >
                                    {t("Products")}
                                </h3>
                                {/* <p>Stay updated with our latest news and insights</p> */}
                            </div>

                            <OwlCarousel className="owl-theme" {...options}>
                                {productList && productList?.length > 0 ? (
                                    productList?.map((item, index) =>
                                        item ? (
                                            <div className="col-xl-4 mt-2 col-lg-4 col-md-6 col-sm-6 w-100"
                                                style={{ height: "100%" }}
                                                onClick={() => handleNavigation(item?.ProductSlug)}
                                                key={index}
                                            >
                                                <div
                                                    className="card shadow-sm rounded-3 h-100 border border-dark"
                                                    style={{
                                                        cursor: "pointer",
                                                        overflow: "hidden",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        justifyContent: "space-between"
                                                    }}
                                                >
                                                    {/* Image Section */}
                                                    <div className="position-relative">
                                                        <img
                                                            src={
                                                                item?.PRODUCT_IMG === null
                                                                    ? batuk
                                                                    : item?.PRODUCT_IMG?.split(",")[0]
                                                            }
                                                            alt={item.PRODUCT_NAME}
                                                            className="card-img-top"
                                                            onError={(e) => {
                                                                e.target.onerror = null;
                                                                e.target.src = batuk;
                                                            }}
                                                            style={{
                                                                height: "175px",
                                                                objectFit: "contain",
                                                                borderTopLeftRadius: "12px",
                                                                borderTopRightRadius: "12px",
                                                                backgroundColor: "#fff"
                                                            }}
                                                        />
                                                    </div>

                                                    {/* Card Body */}
                                                    <div className="card-body p-3 d-flex flex-column justify-content-between flex-grow-1">
                                                        <h6
                                                            className="card-title fw-bold mb-2 "
                                                            style={{
                                                                color: "#8f3246",
                                                                fontSize: "16px",
                                                                minHeight: "45px", // 👈 Ensures uniform height
                                                                lineHeight: "1.3",
                                                                overflow: "hidden",
                                                                textOverflow: "ellipsis",
                                                                display: "-webkit-box",
                                                                WebkitLineClamp: 2,
                                                                WebkitBoxOrient: "vertical",
                                                            }}
                                                        >
                                                            {item.PRODUCT_NAME}
                                                        </h6>

                                                        <div className="mt-auto">
                                                            <span
                                                                className="fw-bold d-block mb-2"
                                                                style={{ fontSize: "16px", color: "#000" }}
                                                            >
                                                                ₹{formatToIndianCurrency(Math.round(item.PRODUCT_PRICE - (item.DiscountAmount || 0)))}
                                                            </span>

                                                            <button
                                                                className="btn w-100"
                                                                style={{
                                                                    backgroundColor: "#8f3246",
                                                                    color: "#fff",
                                                                    borderRadius: "8px",
                                                                    textTransform: "none",
                                                                }}
                                                            >
                                                                {t("Book Puja Now")}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        ) : null
                                    )
                                ) : (
                                    <p className="text-center">No Products available</p>
                                )}
                            </OwlCarousel>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default PopularProducts